import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import BracesTrayContainer from 'app/containers/Accounting/BracesTray'

const AccountingBracesTrayCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>
        {t(R.strings.list_braces_tray)}
      </PageTitle>
      <BracesTrayContainer />
    </>
  )
}
const AccountingBracesTray = memo(
  AccountingBracesTrayCpn,
  isEqual,
)

export default AccountingBracesTray
